import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import WorkFlowEditorRow from './WorkFlowEditorRow';
import FormTitle from '../../../../library/form/components/FormTitle'
import SarasTrans from '../../../../library/notifications/SarasTrans';
import FormButton from '../../../../library/form/components/FormActionButton2';
import { UiView, UiViewHeading, UiTitle, UiAction, UiViewContent } from "../../../../library/layout/Index";

const WorkFlowEditor = (props) => {
    const { formObject, viewData, docTypeId } = props;
    if (!viewData)
        return (null)
    else {
        return (
            <>
                <UiView>
                    <UiViewHeading>
                        <UiTitle>
                            <span>
                                <FormTitle formObject={formObject} value='Work Flow Activity Details' />
                            </span>
                        </UiTitle>
                        <UiAction>
                            <FormButton formObject={formObject}
                                action={{ actionId: "new",  actionParam: { docType: docTypeId }, containerKey: "row" }}
                                className="uiActionButton" text={<SarasTrans value="Add Activity Record" />}></FormButton>
                        </UiAction>
                    </UiViewHeading>
                    <UiViewContent>
                        <ul className="uiListTable">
                            <li className="uiSearchHeading">
                                <ul>
                                    <li className="uiColumn uiColumn50"><SarasTrans value="Sequence No" /></li>
                                    <li className="uiColumn uiColumn200"><SarasTrans value="Activity Name" /></li>
                                    <li className="uiColumn uiColumn100"><SarasTrans value="On Approve" /></li>
                                    <li className="uiColumn uiColumn100"><SarasTrans value="On Reject" /></li>
                                    <li className="uiColumn uiColumn70"><SarasTrans value="Activity Condition" /></li>
                                    <li className="uiColumn uiColumn100"><SarasTrans value="Action" /></li>
                                </ul>
                            </li>
                            {
                                Object.values(viewData).map((row, index) => (
                                    <li className="uiSearchRow uiRow">
                                        <WorkFlowEditorRow formObject={formObject} rowKey={row.rowKey} viewData={row} key={index} />
                                    </li>
                                ))
                            }
                        </ul>
                    </UiViewContent>
                </UiView>
                <div>
                    <FormButton formObject={formObject} className="uiSaveActionButton" text={<SarasTrans value="Save Work Flow" />}
                        action={{ actionId: "save", actionName:"WorkFlow", actionParam: { docType: docTypeId }, containerKey: "row" }}
                    />
                </div>
            </>
        )
    }
}

export default withView(WorkFlowEditor, "WorkFlowTmpl", "")